import React from 'react';
import { Button, message, Popconfirm } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import * as Setting from '../utils/AuthUtils';
import { api } from '../AppConfig';
import { useTranslation } from 'react-i18next';

function DeleteStage(props) {
    const [messageApi, contextHolder] = message.useMessage();
    const { t } = useTranslation();

    // console.warn('props di DeleteStage:', props);
    async function confirm(event) {
        event.preventDefault();
        // messageApi.success('Deleting Stage!')
        const response = await fetch(api.stages().delete(props.stage.id).href, {
            method: 'DELETE', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + Setting.getToken(),
            // 'Content-Type': 'application/x-www-form-urlencoded',
            },
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        })

        const data = await response.json();

        if (!response.ok) {
            console.error('errore qui!:', data.errorMsg);
            messageApi.open({
                type: 'error',
                content: 'Error: '+data.errorMsg,
                duration: 10,
            });
        } else {
            window.location.reload(false);
        }
    }

    return (
        <div>
            {contextHolder}
            <Popconfirm
                title="Delete stage"
                description="Are you sure to delete this stage?"
                onConfirm={confirm}
                okText="Yes"
                cancelText="No"
            >
                <Button danger size="small" icon={<DeleteOutlined />} />
            </Popconfirm>
        </div>
    );
}

export default DeleteStage;
